<template>
  <div class="flex flex-col gap-6">
    <!-- Job Position (input) - NEW according to Figma -->
    <b-text-field
      v-model="jobPosition"
      name="jobPosition"
      :label="$t('publish_mission.step2.job_position_label')"
      :placeholder="$t('publish_mission.step2.job_position_placeholder')"
      data-e2e="step2-job-position"
    />

    <!-- Experience Level (chips) - TEMPORARILY HIDDEN: will be re-enabled later
    <div>
      <b-label class="mb-2 block">{{ $t('publish_mission.step2.experience_level_label') }}</b-label>
      <RadioGroup v-model="selectedExperienceLevel" data-e2e="step2-experience-group">
        <div class="flex flex-wrap gap-2">
          <RadioGroupOption
            v-for="level in experienceLevelOptions"
            :key="level.value"
            v-slot="{ checked }"
            :value="level.value"
            :data-e2e="`step2-experience-${level.value}`"
          >
            <BRadioChip :checked="checked">
              {{ level.label }}
            </BRadioChip>
          </RadioGroupOption>
        </div>
      </RadioGroup>
    </div>
    -->

    <!-- Skills/Expertise Selection (max 5 according to Figma) -->
    <div>
      <b-label class="mb-2 block">{{ $t('publish_mission.step2.skills_label') }}</b-label>
      <p class="text-gray-400 text-sm mb-4">{{ $t('publish_mission.step2.skills_description') }}</p>

      <b-chip-input
        name="skills"
        searchable
        :items="skillsOptions"
        v-model="selectedSkills"
        :max-items="5"
        :placeholder="$t('publish_mission.step2.skills_placeholder')"
        data-e2e="step2-skills-input"
      />
    </div>

    <!-- Description: STAR-guided input with free-text fallback -->
    <b-star-fieldset
      v-model="description"
      context="company"
      allow-free-text
      :label="$t('publish_mission.step2.description_label')"
      data-e2e="step2-description-star"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import BTextField from '~/components/forms/BTextField.vue';
import BStarFieldset from '~/components/forms/BStarFieldset.vue';
import BLabel from '~/components/forms/BLabel.vue';
import BRadioChip from '~/components/forms/radio/BRadioChip.vue';
import BChipInput from '~/components/forms/chip-input/BChipInput.vue';
import { groupByCategory } from '~/utils/categoryGrouping';

const { t } = useI18n();

interface Props {
  initialData?: Record<string, any>;
}

const props = defineProps<Props>();

const emit = defineEmits(['change']);

const skillStore = useSkillStore();

const { skills } = storeToRefs(skillStore);

const jobPosition = ref('');
// TEMPORARILY HIDDEN: will be re-enabled later
// const selectedExperienceLevel = ref<string | null>(null);
const selectedSkills = ref<{ value: string; label: string }[]>([]);
const description = ref('');

const isRestoringData = ref(false);

const skillsOptions = computed(() => groupByCategory(skills.value || []));

// TEMPORARILY HIDDEN: will be re-enabled later
// const experienceLevelOptions = computed(() => [
//   { value: 'junior', label: t('publish_mission.step2.experience_junior') },
//   { value: 'mid', label: t('publish_mission.step2.experience_mid') },
//   { value: 'senior', label: t('publish_mission.step2.experience_senior') },
//   { value: 'expert', label: t('publish_mission.step2.experience_expert') },
// ]);

watch(() => props.initialData, (data) => {

  if (data && Object.keys(data).length > 0) {
    isRestoringData.value = true;
    if (data.job_position) {
      jobPosition.value = data.job_position;
    }
    // TEMPORARILY HIDDEN: will be re-enabled later
    // if (data.experience_level) {
    //   selectedExperienceLevel.value = data.experience_level;
    // }
    if (data.skills) {
      selectedSkills.value = data.skills;
    }
    if (data.description) {
      description.value = data.description;
    }
    nextTick(() => {
      isRestoringData.value = false;
    });
  }
}, { immediate: true, deep: true });

watch([
  jobPosition,
  // TEMPORARILY HIDDEN: selectedExperienceLevel,
  selectedSkills,
  description,
], () => {
  if (isRestoringData.value) return;

  emit('change', {
    job_position: jobPosition.value,
    // TEMPORARILY HIDDEN: experience_level: selectedExperienceLevel.value,
    skills: selectedSkills.value,
    description: description.value,
  });
}, { deep: true });

onMounted(() => {
  skillStore.fetchSkills();
});
</script>
